// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"X5-z","colorTextValue":"Y5-z","swatches":"Z5-z","collapseLink":"_5-z","isCollapsed":"a6-z","dropdown":"b6-z","disabled":"c6-z"};